import {
  GET_DMX_DEVICE_PRESET_BY_ID,
  GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS,
  GET_DMX_DEVICE_PRESET_BY_ID_ERROR,
} from './actionTypes';

export const getDmxDevicePresetById = (user, deviceId, presetId) => {
  return {
    type: GET_DMX_DEVICE_PRESET_BY_ID,
    payload: { user, deviceId, presetId },
  };
};

export const getDmxDevicePresetByIdSuccess = (preset) => {
  return {
    type: GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS,
    payload: { preset },
  };
};

export const getDmxDevicePresetByIdError = (error) => {
  return {
    type: GET_DMX_DEVICE_PRESET_BY_ID_ERROR,
    payload: error,
  };
};
